import { createSlice } from "@reduxjs/toolkit";

// Evaluacion de un participante: la cabecera y su detalle (el resultado de
// cada tema). El detalle se guarda con la evaluacion.
const initialState = {
    defaultEntity: {
        id: 0,
        idParticipante: 0,
        participante: "",
        fecha: new Date().toISOString().substring(0, 10),
        idResponsable: 0,
        responsable: "",
        idTipo: 0,
        idEstado: 2,
        observaciones: "",
        evaluacionDetalle: [],
        fechaRegistro: null,
        usuarioRegistro: null,
        fechaModificacion: null,
        usuarioModificacion: null,
    },
    entity: {
        id: 0,
        idParticipante: 0,
        participante: "",
        fecha: new Date().toISOString().substring(0, 10),
        idResponsable: 0,
        responsable: "",
        idTipo: 0,
        idEstado: 2,
        observaciones: "",
        evaluacionDetalle: [],
        fechaRegistro: null,
        usuarioRegistro: null,
        fechaModificacion: null,
        usuarioModificacion: null,
    },
    listResponsables: [{ id: 0, descripcion: "" }],
    listParticipantes: [{ id: 0, descripcion: "" }],
    listTipos: [{ id: 0, descripcion: "" }],
    listEstados: [{ id: 0, descripcion: "" }],
    listDetalles: [],
    listTemas: [{ id: 0, descripcion: "" }],
    validationActive: {
        idParticipante: false,
        fecha: false,
        idResponsable: false,
        idTipo: false,
    },
    validationMessage: [],
}

export const evaluacionDetalleSlice = createSlice({
    name: "evaluacionDetalle",
    initialState,
    reducers: {
        setEntity: (state, action) => {
            state.entity = action.payload;
        },
        // Datos de la cabecera (participante, fecha, responsable...).
        setData: (state, action) => {
            var { name, value } = action.payload;

            if (name.startsWith("id")) value = parseInt(value)

            state.entity[name] = value
            state.validationActive[name] = true
        },
        // Un campo de una fila del detalle. La fila se busca por su numero.
        setItemValue: (state, action) => {
            var { numero, name, value } = action.payload;

            if (name.startsWith("id")) value = parseInt(value)

            const index = state.entity.evaluacionDetalle.findIndex(item => item.numero === numero);

            if (index >= 0) state.entity.evaluacionDetalle[index][name] = value
        },
        // Reemplaza la lista del detalle: la usa Agregar y Quitar.
        setEvaluacionDetalle: (state, action) => {
            state.entity.evaluacionDetalle = action.payload;
        },
        setListResponsables: (state, action) => {
            state.listResponsables = action.payload;
        },
        setListParticipantes: (state, action) => {
            state.listParticipantes = action.payload;
        },
        setListTipos: (state, action) => {
            state.listTipos = action.payload;
        },
        setListEstados: (state, action) => {
            state.listEstados = action.payload;
        },
        setListDetalles: (state, action) => {
            state.listDetalles = action.payload;
        },
        setListTemas: (state, action) => {
            state.listTemas = action.payload;
        },
        setValidationMessage: (state, action) => {
            state.validationMessage = action.payload;
        },
        activeValidations: (state, action) => {
            Object.keys(state.validationActive).forEach(function (key) {
                state.validationActive[key] = true;
            })
        },
    },
});

export const { setEntity, setData, setItemValue, setEvaluacionDetalle
    , setListResponsables, setListParticipantes, setListTipos, setListEstados
    , setListDetalles, setListTemas, setValidationMessage, activeValidations } = evaluacionDetalleSlice.actions;
export default evaluacionDetalleSlice.reducer;
